import { Pipe, PipeTransform } from '@angular/core';

function encodeHTML(value: string): string {
  const div = document.createElement('div');
  div.textContent = value;
  return div.innerHTML;
}

@Pipe({
  name: 'rtEncodeHTML',
})
export class EncodeHTMLPipe implements PipeTransform {
  public transform(value: string): string {
    return value && typeof value === 'string' ? encodeHTML(value) : value;
  }
}
